export const formatPhoneNumber = number => {
  let result = '';
  for (let i = 0; i < number.length; i++) {
    if (i % 3 === 0) {
      result += ` ${number[i]}`;
    } else {
      result += number[i];
    }
  }
  return result;
};

export const isBrowser = () => typeof window !== 'undefined';
